import { render, staticRenderFns } from "./EkrmGrowthCard.vue?vue&type=template&id=a1ae0f88&scoped=true&"
import script from "./EkrmGrowthCard.vue?vue&type=script&lang=js&"
export * from "./EkrmGrowthCard.vue?vue&type=script&lang=js&"
import style0 from "./EkrmGrowthCard.vue?vue&type=style&index=0&id=a1ae0f88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ae0f88",
  null
  
)

export default component.exports